import { participantsSelector } from '../../store/slices/participantSlice';
import { store } from '../../store';
import { sendWebsocketMessage } from './index';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../proto/plugnmeet_datamessage_pb';
export const onAfterOpenConnection = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const session = store.getState().session;
    const participants = participantsSelector
        .selectAll(store.getState())
        .filter((participant) => { var _a; return participant.sid !== ((_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid); });
    if (!participants.length)
        return;
    participants.sort((a, b) => {
        return a.joinedAt - b.joinedAt;
    });
    const donor = participants[0];
    // send initial chat messages
    const dataMsg = new DataMessage({
        type: DataMsgType.SYSTEM,
        roomSid: session.currentRoom.sid,
        roomId: session.currentRoom.room_id,
        to: donor.sid,
        body: {
            type: DataMsgBodyType.SEND_CHAT_MSGS,
            from: {
                sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
            },
            msg: '',
        },
    });
    sendWebsocketMessage(dataMsg.toBinary());
    // send initial whiteboard elements
    // this is also helpful if user got reconnect
    const whiteboardElms = new DataMessage({
        type: DataMsgType.SYSTEM,
        roomSid: session.currentRoom.sid,
        roomId: session.currentRoom.room_id,
        to: donor.sid,
        body: {
            type: DataMsgBodyType.INIT_WHITEBOARD,
            from: {
                sid: (_f = (_e = session.currentUser) === null || _e === void 0 ? void 0 : _e.sid) !== null && _f !== void 0 ? _f : '',
                userId: (_h = (_g = session.currentUser) === null || _g === void 0 ? void 0 : _g.userId) !== null && _h !== void 0 ? _h : '',
            },
            msg: '',
        },
    });
    sendWebsocketMessage(whiteboardElms.toBinary());
};
